/**
 * Query keys the profile list and its screens share: the list shows a
 * summary of what a screen changes, so both must read (and invalidate) the
 * same cache.
 *
 * Used by: UserProfile and its screens, and outside the profile by the
 * header (GARDEN_PEOPLE_KEY, for the garden switcher) and the tips.
 *
 * @module profileQueries
 */

/** Who tends this garden and whose gardens this person tends (GardenPeopleCard; the header and the tips read it too). */
export const GARDEN_PEOPLE_KEY = ['garden', 'people'] as const;
/** The weather warning preferences (WarningsCard and its row; the details form invalidates it). */
export const ALERT_PREFERENCES_KEY = ['alerts', 'preferences'] as const;
/** The Monday garden email's weekly, monthly or off (MondayEmailScreen and its row). */
export const MONDAY_EMAIL_KEY = ['gardenEmail', 'preference'] as const;
